export default __webpack_public_path__ + "static/media/vegan.e9b5fb37.svg";